import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation.js';
import { observer } from 'mobx-react';

const SubscriptionUpsell = observer(() => {
  const bracket = store.donateForm.subscriptionUpsell.matchingBracket();

  const handleGiftTypeSelection = (event) => {
    store.donateForm.subscriptionUpsell.toggleIsOptedIn(
      bracket.period,
      event.target.checked
    );
  };

  const labelText = () =>
    displayText(bracket.options?.labelText) ||
    t(`views.donate_form.subscription_upsell.${bracket.period}_label`);

  const headerText = () =>
    displayText(bracket.options?.headerText) ||
    t('views.donate_form.subscription_upsell.header');

  const subheaderText = () =>
    displayText(bracket.options?.subheaderText) ||
    t('views.donate_form.subscription_upsell.subheader', {
      period: bracket.period,
    });

  const displayText = (bracketText) => {
    if (bracketText && store.donateForm.profileOwnerName) {
      return bracketText.replace('%{user}', store.donateForm.profileOwnerName);
    } else {
      return bracketText;
    }
  };

  return (
    <>
      <p
        className='p30 font-medium'
        dangerouslySetInnerHTML={{
          __html: headerText(),
        }}
      />
      <p
        className='p40 mt-1'
        dangerouslySetInnerHTML={{
          __html: subheaderText(),
        }}
      />
      <div className='mb-2 text-left relative mt-2 bg-grey-5 border border-solid border-grey-30 rounded p-2'>
        <div className='input-wrapper mb-0'>
          <div className='flex items-center'>
            <label className='label-switch small mb-0' id='upsell-switch'>
              <input
                defaultChecked={''}
                onChange={handleGiftTypeSelection}
                type='checkbox'
              />
              <span className='checkbox block' />
            </label>
            <p
              className='p40 ml-2 font-medium'
              dangerouslySetInnerHTML={{
                __html: t(
                  `views.donate_form.subscription_upsell.${bracket.period}_label_header`,
                  {
                    unit: store.donateForm.currencyUnit,
                    amount: store.donateForm.subscriptionUpsell.amount(),
                  }
                ),
              }}
            />
          </div>

          <p
            className='p40 mt-2'
            dangerouslySetInnerHTML={{
              __html: labelText(),
            }}
          />
        </div>
      </div>
    </>
  );
});

export default SubscriptionUpsell;
